import React from 'react';
import { useTheme } from 'styled-components';
import { ArrowStyled } from './styled';

export enum ArrowDirection {
  top,
  bottom,
  left,
  right
}

export const rotationMap = {
  [ArrowDirection.right]: 'rotate(0deg)',
  [ArrowDirection.left]: 'rotate(180deg)',
  [ArrowDirection.top]: 'rotate(-90deg)',
  [ArrowDirection.bottom]: 'rotate(90deg)'
};

export interface ArrowProps {
  fill?: string;
  direction: ArrowDirection;
  width?: number;
  height?: number;
  disabled?: boolean;
  onClick: () => void;
  ariaLabel?: string;
}
// #98918A
export const Arrow: React.FC<ArrowProps> = ({
  fill,
  direction,
  width = 12,
  height = 12,
  disabled = false,
  onClick = () => {},
  ariaLabel
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (disabled) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <ArrowStyled
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      $direction={direction}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled || undefined}
      aria-label={ariaLabel}
    >
      <path
        fill={disabled ? '#98918a' : (fill ?? theme.colors.text.primary)}
        d="M2.4 10.976 3.449 12l6.15-6-6.15-6-1.05 1.024L7.502 6 2.4 10.976Z"
      />
    </ArrowStyled>
  );
};
